import React,{useState} from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiMail,FiPhone,FiMapPin,FiSend,FiLinkedin,FiCalendar}=FiIcons;

const Contact=()=> {
  const [formData,setFormData]=useState({
    name: '',
    email: '',
    company: '',
    phone: '',
    service: '',
    message: ''
  });

  const handleChange=(e)=> {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit=(e)=> {
    e.preventDefault();
    console.log('Form submitted:',formData);
  };

  const contactInfo=[
    {
      icon: FiMail,
      title: 'Email',
      value: 'leigh@kleinsportsconsulting.com',
      link: 'mailto:leigh@kleinsportsconsulting.com'
    },
    {
      icon: FiPhone,
      title: 'Phone',
      value: 'Available upon request',
      link: '#'
    },
    {
      icon: FiMapPin,
      title: 'Location',
      value: 'United States',
      link: '#'
    },
    {
      icon: FiLinkedin,
      title: 'LinkedIn',
      value: 'Connect with Leigh',
      link: 'https://www.linkedin.com/in/leighalanklein/'
    }
  ];

  const services=[
    'Performance Analytics',
    'Team Development',
    'Strategic Planning',
    'Athletic Coaching',
    'Program Optimization',
    'Sports Consulting'
  ];

  return (
    <section id="contact" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{opacity: 0,y: 30}}
          whileInView={{opacity: 1,y: 0}}
          viewport={{once: true}}
          transition={{duration: 0.8}}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Let's <span className="text-orange-600"> Connect</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Ready to elevate your athletic performance? Let's discuss how our consulting services can help you achieve your goals.
          </p>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-16">
          <motion.div
            initial={{opacity: 0,x: -50}}
            whileInView={{opacity: 1,x: 0}}
            viewport={{once: true}}
            transition={{duration: 0.8}}
            className="space-y-8"
          >
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Get in Touch</h3>
              <p className="text-gray-600 leading-relaxed mb-8">
                Whether you're an individual athlete looking to improve performance or an organization seeking strategic guidance,I'm here to help you reach your full potential.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {contactInfo.map((info,index)=> (
                <motion.a
                  key={info.title}
                  href={info.link}
                  target={info.link.startsWith('http') ? '_blank' : '_self'}
                  rel={info.link.startsWith('http') ? 'noopener noreferrer' : ''}
                  initial={{opacity: 0,y: 20}}
                  whileInView={{opacity: 1,y: 0}}
                  viewport={{once: true}}
                  transition={{duration: 0.6,delay: index * 0.1}}
                  whileHover={{scale: 1.02}}
                  className="flex items-center space-x-4 p-6 bg-gray-50 rounded-xl hover:bg-orange-50 transition-all duration-300 border border-gray-100 hover:border-orange-200"
                >
                  <div className="w-12 h-12 bg-orange-100 rounded-xl flex items-center justify-center">
                    <SafeIcon icon={info.icon} className="w-6 h-6 text-orange-600" />
                  </div>
                  <div>
                    <div className="text-gray-500 text-sm">{info.title}</div>
                    <div className="text-gray-900 font-medium">{info.value}</div>
                  </div>
                </motion.a>
              ))}
            </div>

            <motion.div
              initial={{opacity: 0,y: 30}}
              whileInView={{opacity: 1,y: 0}}
              viewport={{once: true}}
              transition={{duration: 0.8,delay: 0.4}}
              className="bg-orange-600 text-white rounded-2xl p-8"
            >
              <div className="flex items-center mb-4">
                <SafeIcon icon={FiCalendar} className="w-6 h-6 mr-3" />
                <h4 className="text-xl font-bold">Schedule a Consultation</h4>
              </div>
              <p className="text-orange-100 mb-6">
                Book a complimentary consultation to discuss your performance goals and explore how we can work together to achieve them.
              </p>
              <motion.button
                whileHover={{scale: 1.05}}
                whileTap={{scale: 0.95}}
                className="bg-white text-orange-600 px-6 py-3 rounded-lg font-semibold hover:bg-gray-50 transition-colors duration-200"
              >
                Book Now
              </motion.button>
            </motion.div>
          </motion.div>

          <motion.div
            initial={{opacity: 0,x: 50}}
            whileInView={{opacity: 1,x: 0}}
            viewport={{once: true}}
            transition={{duration: 0.8}}
          >
            <form onSubmit={handleSubmit} className="bg-gray-50 rounded-2xl p-8 border border-gray-100">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">Send a Message</h3>
              
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-6">
                <div>
                  <label htmlFor="name" className="block text-gray-700 text-sm font-medium mb-2">
                    Full Name *
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg text-gray-900 focus:outline-none focus:border-orange-500 focus:ring-2 focus:ring-orange-200 transition-all duration-200"
                    placeholder="Enter your name"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block text-gray-700 text-sm font-medium mb-2">
                    Email Address *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg text-gray-900 focus:outline-none focus:border-orange-500 focus:ring-2 focus:ring-orange-200 transition-all duration-200"
                    placeholder="Enter your email"
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-6">
                <div>
                  <label htmlFor="company" className="block text-gray-700 text-sm font-medium mb-2">
                    Organization
                  </label>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    value={formData.company}
                    onChange={handleChange}
                    className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg text-gray-900 focus:outline-none focus:border-orange-500 focus:ring-2 focus:ring-orange-200 transition-all duration-200"
                    placeholder="Your organization"
                  />
                </div>
                <div>
                  <label htmlFor="phone" className="block text-gray-700 text-sm font-medium mb-2">
                    Phone Number
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg text-gray-900 focus:outline-none focus:border-orange-500 focus:ring-2 focus:ring-orange-200 transition-all duration-200"
                    placeholder="Your phone number"
                  />
                </div>
              </div>

              <div className="mb-6">
                <label htmlFor="service" className="block text-gray-700 text-sm font-medium mb-2">
                  Service of Interest
                </label>
                <select
                  id="service"
                  name="service"
                  value={formData.service}
                  onChange={handleChange}
                  className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg text-gray-900 focus:outline-none focus:border-orange-500 focus:ring-2 focus:ring-orange-200 transition-all duration-200"
                >
                  <option value="">Select a service</option>
                  {services.map((service)=> (
                    <option key={service} value={service}>{service}</option>
                  ))}
                </select>
              </div>

              <div className="mb-8">
                <label htmlFor="message" className="block text-gray-700 text-sm font-medium mb-2">
                  Message *
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows={5}
                  className="w-full px-4 py-3 bg-white border border-gray-200 rounded-lg text-gray-900 focus:outline-none focus:border-orange-500 focus:ring-2 focus:ring-orange-200 transition-all duration-200 resize-none"
                  placeholder="Tell us about your goals and how we can help..."
                />
              </div>

              <motion.button
                type="submit"
                whileHover={{scale: 1.02}}
                whileTap={{scale: 0.98}}
                className="w-full bg-orange-600 text-white py-4 rounded-lg font-semibold flex items-center justify-center gap-2 hover:bg-orange-700 transition-colors duration-200 shadow-lg"
              >
                Send Message
                <SafeIcon icon={FiSend} className="w-5 h-5" />
              </motion.button>
            </form>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Contact;